"use strict";

var _objectWithoutProperties = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _objectSpread = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _toConsumableArray = require("/home/runner/work/nft-login-marketplace/nft-login-marketplace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.computeMinFee = void 0;

var sign_1 = require("./sign");

var DEFAULT_MIN_FEE_PER_BYTE = 1000;
var DEFAULT_NUMBER_OF_SIGNATURES = 1;
var DEFAULT_BASE_FEE = '0';
var DEFAULT_SIGNATURE_BYTE_SIZE = 64;

var computeTransactionMinFee = function computeTransactionMinFee(assetSchema, trx, options) {
  var _a, _b, _c, _d, _e;

  var mockSignatures = new Array((_a = options === null || options === void 0 ? void 0 : options.numberOfSignatures) !== null && _a !== void 0 ? _a : DEFAULT_NUMBER_OF_SIGNATURES).fill(Buffer.alloc(DEFAULT_SIGNATURE_BYTE_SIZE));

  if (options === null || options === void 0 ? void 0 : options.numberOfEmptySignatures) {
    mockSignatures.push.apply(mockSignatures, _toConsumableArray(new Array(options.numberOfEmptySignatures).fill(Buffer.alloc(0))));
  }

  var size = sign_1.getBytes(assetSchema, _objectSpread({}, trx, {
    signatures: mockSignatures
  })).length;
  var baseFee = (_d = (_c = (_b = options === null || options === void 0 ? void 0 : options.baseFees) === null || _b === void 0 ? void 0 : _b.find(function (bf) {
    return bf.moduleID === trx.moduleID && bf.assetID === trx.assetID;
  })) === null || _c === void 0 ? void 0 : _c.baseFee) !== null && _d !== void 0 ? _d : DEFAULT_BASE_FEE;
  return BigInt(size * ((_e = options === null || options === void 0 ? void 0 : options.minFeePerByte) !== null && _e !== void 0 ? _e : DEFAULT_MIN_FEE_PER_BYTE)) + BigInt(baseFee);
};

var computeMinFee = function computeMinFee(assetSchema, trx, options) {
  var fee = trx.fee,
      trxWithoutFee = _objectWithoutProperties(trx, ["fee"]);

  trxWithoutFee.fee = BigInt(0);
  var minFee = computeTransactionMinFee(assetSchema, trxWithoutFee, options);

  while (minFee > BigInt(trxWithoutFee.fee)) {
    trxWithoutFee.fee = minFee;
    minFee = computeTransactionMinFee(assetSchema, trxWithoutFee, options);
  }

  return minFee;
};

exports.computeMinFee = computeMinFee;